import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useAsync } from '@sde/widgets-core/src/redux/hooks/useAsync';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { postPdf, clearResults } from './actions';
import { POST_PDF, CLEAR_RESULTS } from './constants';

const uploadDataSelector = (state) => state.upload;

export const useFileUpload = {
  state: () => {
    return useSelect(uploadDataSelector);
  },
  actions: () => {
    return {
      postPdf: useAction(postPdf, {
        saga: useAsync(POST_PDF),
      }),
      clearResults: useAction(clearResults, {
        saga: useAsync(CLEAR_RESULTS),
      }),
    };
  },
};
